import { getStateFromPath } from '@react-navigation/native';
import { DecodedSpecialUrlCode, SpecialUrlCode } from '../../urlCodeHelpers';
import { AbstractPathResolver, PathResolveResult } from '../PathResolver';

export class ReviewPathResolver extends AbstractPathResolver {
  resolveStateFromPath(): PathResolveResult {
    const { urlPath, options } = this.context;
    if (SpecialUrlCode.isReview(urlPath)) {
      const { reviewId } = DecodedSpecialUrlCode.decodeReview(urlPath);
      return this.parseQs(getStateFromPath(`/review/${reviewId}`, options));
    }
  }
}
